const multiStepInlineForm = () => {
    const multiStepCta = document.querySelector('.c-multi-cta');

    if (!multiStepCta) {
        return;
    }

    let selectedOptions = [];
    const financialModal = document.querySelector('#inline-legal-modal .c-modal');
    financialModal?.classList.add('c-hero-modal', 'c-hero-modal--legal');

    radioButtonListeners(multiStepCta, selectedOptions);
    backButtonListeners(multiStepCta, selectedOptions);
}

const radioButtonListeners = (currentMultiStepCTA, selectedOptions) => {
    currentMultiStepCTA.addEventListener('click', (e) => {
        const radioButton = e.target.closest('.js-modal-radio');
        if (radioButton) {
            const currentStepNumber = radioButton.closest('.c-multi-cta__step').dataset.step;
            const nextStep = currentMultiStepCTA.querySelector(`[data-step="${Number(currentStepNumber) + 1}"]`);
            const lastStep = currentMultiStepCTA.querySelector('[data-step]:last-child');

            if (nextStep) {
                handleStepChange(currentStepNumber, Number(currentStepNumber) + 1, currentMultiStepCTA);
                selectedOptions[currentStepNumber - 1] = {
                    value: radioButton.value,
                    question: radioButton.dataset.modalOptions
                };
            }

            if (!nextStep && lastStep) {
                selectedOptions[currentStepNumber - 1] = {
                    value: radioButton.value,
                    question: radioButton.dataset.modalOptions
                };
                appendInputFields(selectedOptions);
                openModal();
            }
        }
    });
}

const appendInputFields = (selectedOptions) => {
    const modalForm = document.querySelector('#inline-legal-modal .js-validateForm');
    const requestedServiceDetail = modalForm.querySelector('[name="requested_service_detail"]');
    let newRequestedServiceDetail = '';

    selectedOptions.forEach(option => {
        const { value } = option;
        newRequestedServiceDetail += `${value} | `;
    });

    requestedServiceDetail.value = newRequestedServiceDetail;

    addCloseButtonListener(requestedServiceDetail);
}

const addCloseButtonListener = (hiddenInput) => {
    document.getElementById('inline-legal-modal').addEventListener("click", function(e) {
        if (e.target.hasAttribute("data-micromodal-close")) {
            hiddenInput.value = '';
        }
    });
};

const backButtonListeners = (currentMultiStepCTA, selectedOptions) => {
    currentMultiStepCTA.addEventListener('click', (e) => {
        const backButton = e.target.closest('[data-previous-step]');

        if (backButton) {
            e.preventDefault();
            const currentStepNumber = backButton.closest('.c-multi-cta__step').dataset.step;
            const previousStep = currentMultiStepCTA.querySelector(`[data-step="${Number(currentStepNumber) - 1}"]`);

            if (previousStep) {
                handleStepChange(currentStepNumber, Number(currentStepNumber) - 1, currentMultiStepCTA);
                restoreSelectedRadioButton(previousStep, selectedOptions, currentStepNumber);
            }
        }
    });
}

const restoreSelectedRadioButton = (step, selectedOptions, currentStepNumber) => {
    const selectedOption = selectedOptions[Number(currentStepNumber) - 2];
    const radioButton = step.querySelector(`.js-modal-radio[value="${selectedOption.value}"]`);

    if (selectedOption && radioButton) {
        radioButton.checked = true;
    }
}

const handleStepChange = (currentStep, nextStep, form) => {
    if(nextStep) {
        transitionSteps(currentStep, nextStep, form);
    }
}

const transitionSteps = (currentStep, nextStep, form) => {
    var activeStep = form.querySelector('[data-step="' + currentStep + '"]');
    var targetStep = form.querySelector('[data-step="'+ nextStep +'"]');
    fadeOut(activeStep, 300, function() {
        fadeIn(targetStep, 300, function() {
            activeStep.classList.remove('is-active');
            targetStep.classList.add('is-active');
        });
    });
}

const openModal = () => {
    document.querySelector('#inline-legal-modal .mfp-wrap').style.overflow = 'hidden auto';;

    MicroModal.show('inline-legal-modal',{
        disableScroll: true,
    });
}

// Fade out helper
const fadeOut = (element, time, cb) => {
    var op = 1;  // initial opacity
    var timer = setInterval(function () {
        if (op <= 0.1){
            clearInterval(timer);
            element.style.display = 'none';
            if (cb) {
                cb();
            }
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op -= 50 / time;
    }, 50);
}

// Fade in helper
const fadeIn = (element, time, cb) => {
    var op = 0;  // initial opacity
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op + ")";
    element.style.display = 'flex';
    var timer = setInterval(function () {
        if (op >= 1){
            clearInterval(timer);
            if (cb) {
                cb();
            }                            }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op += 50 / time;
    }, 50);
}

multiStepInlineForm();